<article class="buttonAttachFile">
  <label for="attachFileInput">
    <div
      class="buttonAttachFile__button button"
      [ngClass]="{ 'button--uploaded': iconUpload === 'done' }"
    >
      <mat-icon
        class="button__icon"
        matTooltip="Upload new file (File type PDF and max size 5MB)"
      >
        {{ iconUpload }}
      </mat-icon>
    </div>
    <span class="button__text">
      {{ uploadText }}
    </span>
  </label>
  <input id="attachFileInput" type="file" [accept]="fileTypes" />
</article>
